import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/reset.css'; // first, so every other stylesheet wins over it
import App from './App';
import './styles/hireform.css';
import { installSessionHeader } from './utils/sessionHeader';

// Every call to our own Netlify functions carries the driver's session token
// (functions/session-auth.js checks it). Installed before anything renders.
installSessionHeader();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
